const messages = {
    availPoints: "Dostupni poeni",
    awaitingPoints: "Poeni na čekanju",
  board: {
    title: "Kontrolna tabla",
    title2: "Animacija performansi {year}",
    headline1: "Vaše promocije i poeni na prvi pogled",
    headline2: "Зарадите поене за куповину гума.",
    pointsBalanceToDate: "STANJE POENA NA DAN",
    availPoints: "Dostupni poeni",
    awaitingPoints: "Poeni na čekanju",
    yourRealisation: "ВАША ПОСТИГНУЋА",
    yourEngagement: "Ваша годишња обавеза: <б>__ТИРЕС__ гуме</б>",
    yourPoints: "ВАШИ ПОЕНА",
    yourRetailPurchase: "ВАШЕ МАЛОПРОДАЈНЕ КУПОВИНЕ",
    yourRetailPurchaseCCS: "ВАША МАЛОПРОДАЈА",
    pointsByPurchase: "бодове генерисане вашим куповинама",
    pointsByBoosters: "поена које генеришу појачивачи",
    pointsByBSPurchase: "Поени генерисани вашим Бридгестоне куповинама",
    pointsByBSPurchaseCCS:
      "Поени генерисани продајом Бридгестоне гума",
    remaining: "Преостале гуме",
    yourGoal: "Напредак циља",
    unit: "гуме",
    buttons: {
      learnMore: "Saznajte više o svojim poenima",
      learnMoreAboutMechanism: "Сазнајте више about the mechanics",
    },
    charts: {
      byBrand: "По бренду",
      bySize: "По<бр/>величини обода",
    },
    exploreResults: "Откријте своје резултате",
    tyreLimitInfo:
      "Минимална количина распродата од 50 Бридгестоне и/или Фирестоне гума је потребна за сваки период кампање за појачавање",
  },
  charts: {
    byBrand: "По бренду",
    bySize: "по величини обода",
  },

  dashboard: {
    dashboardTitle: "Vaše pogodnosti",
    dashboardBox: {
      title: "Биланс поена",
      description: "Ваши тренутни маркетиншки поени укупно",
      availPoints: "Dostupni poeni",
      awaitingPoints: "Poeni na čekanju",
      lastUpdate: "Последње ажурирање",
      button: "Сазнајте више",
      points: "points",
    },
  },
  soldTyres: "ГУМЕ ПРОДАТЕ",
  receivedPoints: "ЗАРАЂЕНИ ПОЕНА",
  boosterCCS: {
    personalInfo: "Лични подаци",
    csNumberTitle: "Наведите бројеве рачуна који учествују",
    tyresTitle: "Наведите број продатих гума",
    minTyresInfo:
      "Потребно је најмање __ТИРЕС__ Бридгестоне/Фирестоне гума. Надокнада се односи само на Бридгестоне гуме.",
    tyresAmount: "Број гума",
    filesTitle: "Отпремите свој доказ о продаји",
    filesDescription:
      "Имајте на уму: разматраће се само продаја која наводи величину фелна.",
    addAnotherFile: "Додајте још један документ",
    file: "Отпремите документ",
    formatInfo:
      "Прихваћени формати датотека: клск, јпег и пдф. Максимална величина датотеке: 8 МБ",
    confrimationMessage:
      "<б>Хвала вам на учешћу!</б> <бр/>Ваш захтев је примљен и прослеђен Бридгестоне тимовима на валидацију.<бр/>Примићете обавештење е-поштом са резултатима вашег Боостер ЦЦС учешћа.<бр/>Видимо се ускоро на Бридгестоне Плус!",
  },
  sharePointModal: {
    header: "Делите поене",
    forShare: "Поени које ћете поделити",
    title: "Наслов",
  },
  notFoundFile: "Није изабрано",
  chooseFile: "Изаберите датотеку",
};
export default {
  messages,
};
